const country = {
  阿富汗: '004',
  阿尔巴尼亚: '008',
  南极洲: '010',
  阿尔及利亚: '012',
  美属萨摩亚: '016',
  安道尔: '020',
  安哥拉: '024',
  安提瓜和巴布达: '028',
  阿塞拜疆: '031',
  阿根廷: '032',
  澳大利亚: '036',
  奥地利: '040',
  巴哈马: '044',
  巴林: '048',
  孟加拉国: '050',
  亚美尼亚: '051',
  巴巴多斯: '052',
  比利时: '056',
  百慕大: '060',
  不丹: '064',
  玻利维亚: '068',
  波黑: '070',
  博茨瓦纳: '072',
  布韦岛: '074',
  巴西: '076',
  伯利兹: '084',
  英属印度洋领地: '086',
  所罗门群岛: '090',
  英属维尔京群岛: '092',
  文莱: '096',
  保加利亚: '100',
  缅甸: '104',
  布隆迪: '108',
  白俄罗斯: '112',
  柬埔寨: '116',
  喀麦隆: '120',
  加拿大: '124',
  佛得角: '132',
  开曼群岛: '136',
  中非: '140',
  斯里兰卡: '144',
  乍得: '148',
  智利: '152',
  圣诞岛: '162',
  '科科斯（基林）群岛': '166',
  哥伦比亚: '170',
  科摩罗: '174',
  马约特: '175',
  刚果共和国: '178',
  刚果民主共和国: '180',
  库克群岛: '184',
  哥斯达黎加: '188',
  克罗地亚: '191',
  古巴: '192',
  塞浦路斯: '196',
  捷克: '203',
  贝宁: '204',
  丹麦: '208',
  多米尼克: '212',
  多米尼加: '214',
  厄瓜多尔: '218',
  萨尔瓦多: '222',
  赤道几内亚: '226',
  埃塞俄比亚: '231',
  厄立特里亚: '232',
  爱沙尼亚: '233',
  法罗群岛: '234',
  福克兰群岛: '238',
  南乔治亚和南桑威奇群岛: '239',
  斐济: '242',
  芬兰: '246',
  奥兰: '248',
  法国: '250',
  法属圭亚那: '254',
  法属波利尼西亚: '258',
  法属南部和南极领地: '260',
  吉布提: '262',
  加蓬: '266',
  格鲁吉亚: '268',
  冈比亚: '270',
  巴勒斯坦: '275',
  德国: '276',
  加纳: '288',
  直布罗陀: '292',
  基里巴斯: '296',
  希腊: '300',
  格陵兰: '304',
  格林纳达: '308',
  瓜德罗普: '312',
  关岛: '316',
  危地马拉: '320',
  几内亚: '324',
  圭亚那: '328',
  海地: '332',
  赫德岛和麦克唐纳群岛: '334',
  梵蒂冈: '336',
  洪都拉斯: '340',
  匈牙利: '348',
  冰岛: '352',
  印度: '356',
  印度尼西亚: '360',
  伊朗: '364',
  伊拉克: '368',
  爱尔兰: '372',
  以色列: '376',
  意大利: '380',
  科特迪瓦: '384',
  牙买加: '388',
  日本: '392',
  哈萨克斯坦: '398',
  约旦: '400',
  肯尼亚: '404',
  朝鲜: '408',
  韩国: '410',
  科威特: '414',
  吉尔吉斯斯坦: '417',
  老挝: '418',
  黎巴嫩: '422',
  莱索托: '426',
  拉脱维亚: '428',
  利比里亚: '430',
  利比亚: '434',
  列支敦士登: '438',
  立陶宛: '440',
  卢森堡: '442',
  马达加斯加: '450',
  马拉维: '454',
  马来西亚: '458',
  马尔代夫: '462',
  马里: '466',
  马耳他: '470',
  马提尼克: '474',
  毛里塔尼亚: '478',
  毛里求斯: '480',
  墨西哥: '484',
  摩纳哥: '492',
  蒙古国: '496',
  摩尔多瓦: '498',
  黑山: '499',
  蒙特塞拉特: '500',
  摩洛哥: '504',
  莫桑比克: '508',
  阿曼: '512',
  纳米比亚: '516',
  瑙鲁: '520',
  尼泊尔: '524',
  荷兰: '528',
  库拉索: '531',
  阿鲁巴: '533',
  荷属圣马丁: '534',
  荷兰加勒比区: '535',
  新喀里多尼亚: '540',
  瓦努阿图: '548',
  新西兰: '554',
  尼加拉瓜: '558',
  尼日尔: '562',
  尼日利亚: '566',
  纽埃: '570',
  诺福克岛: '574',
  挪威: '578',
  北马里亚纳群岛: '580',
  美国本土外小岛屿: '581',
  密克罗尼西亚联邦: '583',
  马绍尔群岛: '584',
  帕劳: '585',
  巴基斯坦: '586',
  巴拿马: '591',
  巴布亚新几内亚: '598',
  巴拉圭: '600',
  秘鲁: '604',
  菲律宾: '608',
  皮特凯恩群岛: '612',
  波兰: '616',
  葡萄牙: '620',
  几内亚比绍: '624',
  东帝汶: '626',
  波多黎各: '630',
  卡塔尔: '634',
  留尼汪: '638',
  罗马尼亚: '642',
  俄罗斯: '643',
  卢旺达: '646',
  圣巴泰勒米: '652',
  '圣赫勒拿、阿森松和特里斯坦-达库尼亚': '654',
  圣基茨和尼维斯: '659',
  安圭拉: '660',
  圣卢西亚: '662',
  法属圣马丁: '663',
  圣皮埃尔和密克隆: '666',
  圣文森特和格林纳丁斯: '670',
  圣马力诺: '674',
  圣多美和普林西比: '678',
  沙特阿拉伯: '682',
  塞内加尔: '686',
  塞尔维亚: '688',
  塞舌尔: '690',
  塞拉利昂: '694',
  新加坡: '702',
  斯洛伐克: '703',
  越南: '704',
  斯洛文尼亚: '705',
  索马里: '706',
  南非: '710',
  津巴布韦: '716',
  西班牙: '724',
  南苏丹: '728',
  苏丹: '729',
  阿拉伯撒哈拉民主共和国: '732',
  苏里南: '740',
  斯瓦尔巴和扬马延: '744',
  斯威士兰: '748',
  瑞典: '752',
  瑞士: '756',
  叙利亚: '760',
  塔吉克斯坦: '762',
  泰国: '764',
  多哥: '768',
  托克劳: '772',
  汤加: '776',
  特立尼达和多巴哥: '780',
  阿联酋: '784',
  突尼斯: '788',
  土耳其: '792',
  土库曼斯坦: '795',
  特克斯和凯科斯群岛: '796',
  图瓦卢: '798',
  乌干达: '800',
  乌克兰: '804',
  北马其顿: '807',
  埃及: '818',
  英国: '826',
  根西: '831',
  泽西: '832',
  马恩岛: '833',
  坦桑尼亚: '834',
  美国: '840',
  美属维尔京群岛: '850',
  布基纳法索: '854',
  乌拉圭: '858',
  乌兹别克斯坦: '860',
  委内瑞拉: '862',
  瓦利斯和富图纳: '876',
  萨摩亚: '882',
  也门: '887',
  赞比亚: '894'
};

export default country;
